<template>
  <div class="tbe-calendar">
    <label class="tbe-calendar__label">Tour date</label>
    <date-picker
      ref="calendarRef"
      :modelValue="date"
      @update:modelValue="handleChangeDate"
      :min-date="minDate"
      :max-date="maxDate"
      :locale="locale"
      :first-day-of-week="generalSettings.first_day_of_week.day"
      :is-expanded="displaySettings.is_calendar_full_width || displaySettings.is_widget"
      :style="{ border: 'none' }"
      :select-attribute="{
        highlight: {
          style: { backgroundColor: appearanceSettings.design.accent_color },
          contentStyle: { color: '#fff' }
        }
      }"
      :columns="$screens({ default: 1, lg: 2 })"
      :attributes="attributes"
      :disabled-dates="disabledDates"
      :masks="{ input: 'WWW, MMM DD, YYYY' }"
      :is-required="true"
    >
      <template v-slot="{ inputValue, inputEvents }">
        <div class="tbe-calendar-dropdown">
          <input
            class="tbe-input tbe-calendar-dropdown__control"
            :value="inputValue"
            v-on="inputEvents"
            readonly="readonly"
          />
        </div>
      </template>
    </date-picker>
  </div>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from 'vuex'
  import { DatePicker } from 'v-calendar'
  import { add, isPast, parse } from 'date-fns'
  import { useI18n } from 'vue-i18n'

  const currentDate = new Date()
  currentDate.setHours(0, 0, 0)

  export default {
    name: 'tbeCalendar',

    components: { DatePicker },

    setup() {
      const { t } = useI18n()
      const store = useStore()

      const date = computed(() => store.state.booking.order.date)
      const minDate = ref(currentDate)
      const maxDate = ref(add(currentDate, { years: 1 }))

      const generalSettings = computed(() => store.state.app.generalSettings)
      const appearanceSettings = computed(() => store.state.app.appearanceSettings)
      const displaySettings = computed(() => store.state.app.displaySettings)
      const locale = computed(() => store.state.app.locale)

      const availabilities = computed(() => store.state.booking.availabilities)

      const disabledDates = computed(() => {
        return availabilities.value.map((availability) => availability.date)
      })

      const attributes = computed(() => {
        const dates = availabilities.value.reduce((acc, availability) => {
          const date = parse(availability.date, 'yyyy-MM-dd', new Date())
          if (!isPast(date)) return [...acc, date]
          return acc
        }, [])
        return [
          {
            highlight: {
              color: 'pink',
              fillMode: 'light'
            },
            popover: {
              label: 'Sorry, this day is not available, please choose another day.',
              hideIndicator: true,
              visibility: 'focus'
            },
            dates
          }
        ]
      })

      const handleChangeDate = (date) => store.dispatch('booking/setDate', date)

      return {
        t,

        date,
        minDate,
        maxDate,
        disabledDates,

        generalSettings,
        appearanceSettings,
        displaySettings,
        locale,

        attributes,

        handleChangeDate
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-calendar-dropdown {
    &__control {
      width: 100%;
    }
  }

  .tbe-calendar {
    &__label {
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
</style>
